import React, { Component } from "react";
import Accordion from "../../common/components/accordion";
import FormStep from "../../common/components/formStep";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import ParsonalBankUseOnly from "../../common/components/pageBlocks/personalDetails/personalBankUseOnly";
import commonContext, { AppContext } from "../../common/context/common";
import BackContinueButton from "../../common/components/pageBlocks/backContinueButton";
import EmploymentDetailsCard from "../../common/components/pageBlocks/personalDetails/employmentDetailsCard";
import PersonalDetailsCard from "../../common/components/pageBlocks/personalDetails/personalDetailsCard";
import { leadType, offerType } from "../../app";
import { Qm10SecApis } from "../apis/qm10SecApis";
interface IProps {
    history: any;
}
interface IState {}
class PersonalDetails extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    offer: offerType;
    apis: Qm10SecApis;
    setLead: Function;
    steps = [
        { title: "Vehicle" },
        { title: "Loan" },
        { title: "Review" },
        { title: "Personal", active: true },
        { title: "Confirmation" },
    ];
    async componentDidMount() {
        this.apis = (this.context as AppContext).apis as Qm10SecApis;
        this.lead = (this.context as AppContext).lead as leadType;
        this.offer = (this.context as AppContext).offer as offerType;
        this.setLead = (this.context as AppContext).setLead;
        const apiData = await this.apis.getStates(this.lead);

        this.setLead({
            pdPresentMobile: this.offer.mobile,
            pdPresentEmail: this.offer.email,
            pdFirstName: this.offer.pdApplicantFirstName,
            pdLastName: this.offer.pdApplicantLastName,
            pdMiddleName: this.offer.pdApplicantMiddleName,
            pdPresentAddress: this.offer.pdPresentAddress1,
            pdPresentAddress2: this.offer.pdPresentAddress2,
            pdPresentAddress3: this.offer.pdPresentAddress3,
            pdCity: this.offer.pdPresentCity,
            pdLandmark: this.offer.pdPresentLandMark,
            pdPinCode: this.offer.pdPresentPin,
            pdState: this.offer.pdPresentState,
            pdPanNo: this.offer.pdPanNo,
            pdDob: this.offer.dob,
            pdSex: this.offer.sex,
            statesArray: apiData.result,
        });
    }
    handleOnSubmit = async (e) => {
        window.scrollTo(0, 0);
        e.preventDefault();
        this.lead = (this.context as AppContext).lead as leadType;
        await this.setLead({ loadingBtn: "loadingBtn" });
        const apiData = await this.apis.updatePersonalInfoData(this.lead);
        await this.setLead({ loadingBtn: "" });
        if (apiData.result) {
            this.props.history.push("sanction-letter-approval");
        }
    };
    render() {
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="personal-details-wrap mt-110">
                        <form onSubmit={(e) => this.handleOnSubmit(e)}>
                            <div className="container mx-auto px-5">
                                <FormStep steps={this.steps} />
                                <PersonalDetailsCard />
                                <EmploymentDetailsCard />
                            </div>
                            <div className="container my-5 mx-auto sm:px-2 md:px-5">
                                <div className="accord-wrap">
                                    <Accordion title="Bank Use Only">
                                        <ParsonalBankUseOnly />
                                    </Accordion>
                                </div>
                            </div>
                            <div className="container mx-auto px-5">
                                <BackContinueButton backPath="review" />
                            </div>
                        </form>
                    </section>
                </div>
            </>
        );
    }
}

export default PersonalDetails;
